import * as colors from 'tailwindcss/colors.js'

export default {
  ...{
    primary: '#52ae49',
    'primary-content': '#ffffff',
    secondary: '#974b78',
    'secondary-content': '#ffffff',
    white: '#ffffff',
    black: '#000000',
    warning: '#f5a623',
    error: '#d0021b',
    info: '#4a90e2',
    gray: {
      ...colors.gray,
      DEFAULT: '#999999',
      inactive: '#cdcdcd',
      active: '#666666'
    },
    base: {
      100: '#f8f8f8',
      200: '#f2f2f2',
      300: '#ececec'
    },
    score: {
      1: '#52ae49',
      2: '#a5cc06',
      3: '#ffd700',
      4: '#ffa000',
      5: '#ff573b',
      6: '#9d1600',
      7: '#b419a0'
    },
    'score-reverse': {
      1: '#ff573b',
      2: '#ffa000',
      3: '#ffd700',
      4: '#a5cc06',
      5: '#52ae49'
    },
    purple: {
      1: '#e9e2f2',
      2: '#d2c5e5',
      3: '#baa7d8',
      4: '#a389ca',
      5: '#8d6dbe'
    },
    'score-primary': {
      1: '#dcefdb',
      2: '#badfb6',
      3: '#97ce92',
      4: '#75be6d',
      5: '#52ae49'
    },
    'score-secondary': {
      1: '#eadbe4',
      2: '#d5b7c9',
      3: '#c193ae',
      4: '#ac6f93',
      5: '#974b78'
    },
    chart: { // mit https://mycolor.space/ aus unserer primary und secondary generiert
      1: '#FB7121',
      2: '#009FFF',
      3: '#52AE49',
      4: '#7BB0E0',
      5: '#006FBD',
      6: '#974B78',
      7: '#477000'
    }
  }
}
